import i18next from '../languages';

const menu = [
  {
    showing: true,
    icon: 'ni ni-chart-bar-32',
    label: i18next.t('Anasayfa'),
    to: { name: 'home' },
    color: 'primary',
  },
  {
    showing: true,
    icon: 'ni ni-briefcase-24',
    label: i18next.t('Hızlı Satış'),
    to: { name: 'create-order' },
    color: 'info',
  },
  {
    showing: true,
    icon: 'ni ni-paper-diploma',
    label: i18next.t('Çalışan ve Maaşlar'),
    to: { name: 'employees-and-salaries' },
    color: 'pink',
  },
  {
    showing: true,
    icon: 'ni ni-atom',
    label: i18next.t('Ürün Yönetimi'),
    to: { name: 'services' },
    color: 'orange',
    children: [
      {
        icon: 'ni ni-bullet-list-67',
        label: i18next.t('Tüm Ürünler'),
        to: { name: 'services' },
      },
      // {
      //     icon: "ni ni-bullet-list-67",
      //     label: i18next.t("Gelecek Ürünler"),
      //     to: {name: "newservices"},
      // },
      // {
      //     icon: "ni ni-bullet-list-67",
      //     label: i18next.t("Silinen Ürünler"),
      //     to: {name: "deleted-services"},
      // },
      // {
      //     icon: "ni ni-bullet-list-67",
      //     label: i18next.t("Kiradaki Ürünler"),
      //     to: {name: "leased-products"},
      // },
      //
      // {
      //     icon: "ni ni-bullet-list-67",
      //     label: i18next.t("Terzideki Ürünler"),
      //     to: {name: "tailor-products"},
      // },
      //
      // {
      //     icon: "ni ni-bullet-list-67",
      //     label: i18next.t("Kuru Temizlemedeki Ürünler"),
      //     to: {name: "dry-products"},
      // },
    ],
  },
  // {
  //   showing: true,
  //   icon: 'ni ni-bullet-list-67',
  //   label: i18next.t('Yeni Ürün Siparişi'),
  //   to: { name: 'super-products' },
  //   color: 'info',
  // },
  {
    showing: true,
    icon: 'ni ni-bag-17',
    label: i18next.t('Süreli Hizmetler'),
    to: { name: 'sureli-hizmetler' },
  },
  {
    showing: true,
    icon: 'ni ni-bag-17',
    label: i18next.t('Kasa'),
    to: { name: 'safe' },
    children: [
      {
        icon: 'ni ni-bag-17',
        label: i18next.t('Günlük Kasa'),
        to: { name: 'safe' },
      },
      {
        icon: 'ni ni-bag-17',
        label: i18next.t('Geçmiş Gün Sonları'),
        to: { name: 'gecmis-kasa' },
      },
      {
        icon: 'ni ni-fat-add',
        label: i18next.t('Genel Giderler'),
        to: { name: 'generalExpenses' },
      },
    ],
    color: 'secondary',
  },
  {
    showing: true,
    icon: 'ni ni-circle-08',
    label: i18next.t('Cari Yönetimi'),
    to: { name: 'clients' },
    color: 'primary',
    children: [
      {
        icon: 'ni ni-fat-add',
        label: i18next.t('Yeni Cari'),
        to: { name: 'create-client' },
      },
      {
        icon: 'ni ni-bullet-list-67',
        label: i18next.t('Cari Listele'),
        to: { name: 'clients' },
      },
      {
        icon: 'ni ni-book-bookmark',
        label: i18next.t('Cari İşlemleri'),
        to: { name: 'reports' },
      },
    ],
  },

  {
    showing: true,
    icon: 'ni ni-circle-08',
    label: i18next.t('Raporlar'),
    to: { name: 'clients' },
    color: 'primary',
    children: [
      {
        icon: 'ni ni-fat-add',
        label: i18next.t('Satış Raporları'),
        to: { name: 'sales-reports' },
      },
      {
        icon: 'ni ni-bullet-list-67',
        label: i18next.t('Ürün Raporları'),
        to: { name: 'services-reports' },
      },
      {
        icon: 'ni ni-book-bookmark',
        label: i18next.t('Gelir Gider Raporları'),
        to: { name: 'incomeexpenses-reports' },
      },
      {
        icon: 'ni ni-book-bookmark',
        label: i18next.t('Çalışan Raporları'),
        to: { name: 'employee-reports' },
      },
    ],
  },

  {
    showing: true,
    icon: 'ni ni-circle-08',
    label: i18next.t('Alacak & Verecek'),
    to: { name: 'clients' },
    color: 'primary',
    children: [
      {
        icon: 'ni ni-fat-add',
        label: i18next.t('Yaklaşan Alacaklar'),
        to: { name: 'accountings-credit' },
        params: { id: 'credit' },
      },
      {
        icon: 'ni ni-bullet-list-67',
        label: i18next.t('Yaklaşan Ödemeler'),
        to: { name: 'accountings-credit' },
        params: { id: 'debt' },
      },
    ],
  },
  {
    showing: true,
    icon: 'ni ni-calendar-grid-58',
    label: i18next.t('Randevular'),
    color: 'yellow',
    children: [
      {
        icon: 'ni ni-calendar-grid-58',
        label: i18next.t('Randevu Takvimi'),
        to: { name: 'appointments' },
      },
      {
        icon: 'ni ni-bullet-list-67',
        label: i18next.t('Liste Görünüm'),
        to: { name: 'appointments-list' },
      },
    ],
  },
  // {
  //   showing: true,
  //   icon: 'ni ni-calendar-grid-58',
  //   label: i18next.t('Kuaför Randevuları'),
  //   color: 'blue',
  //   children: [
  //     {
  //       icon: 'ni ni-calendar-grid-58',
  //       label: i18next.t('Kuaför Takvimi'),
  //       to: { name: 'coiffeur-appointments' },
  //     },
  //     {
  //       icon: 'ni ni-bullet-list-67',
  //       label: i18next.t('Liste Görünüm'),
  //       to: { name: 'coiffeur-appointments-list' },
  //     },
  //   ],
  // },
  {
    showing: true,
    icon: 'ni ni-send',
    label: i18next.t('SMS Modülü'),
    to: { name: 'sms' },
    color: 'default',
  },
  {
    showing: true,
    icon: 'ni ni-check-bold',
    label: i18next.t('Tanımlamalar'),
    to: { name: 'definitions' },
    color: 'info',
  },
  {
    showing: true,
    icon: 'ni ni-settings',
    label: i18next.t('Ayarlar'),
    to: { name: 'settings' },
    color: 'pink',
  },
];

export default menu;
